/**
 * Creates an object composed of properties keyed by `key`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key.
 *
 * @since 2018-06-24
 *
 * @param {Array}  collection - Array of Objects to group.
 * @param {String} key        - Property to group by.
 * @returns {Object} The composed aggregate object.
 * @example
 *
 * groupBy(['one', 'two', 'three'], 'length')
 * // => {3: ["one", "two"], 5: ["three"]}
 */
function groupBy(collection, key) {
  return collection.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

export default groupBy;
